export const SpinnerSize = {
  SMALL: 16,
  MEDIUM: 32,
  LARGE: 100
};
